import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  const footerLinks = {
    Product: [
      { label: 'Solutions', path: '/solutions' },
      { label: 'Industries', path: '/industries' },
      { label: 'Case Studies', path: '/case-studies' },
      { label: 'Pricing', path: '/contact#contact-form' },
    ],
    Company: [
      { label: 'About Us', path: '/about' },
      // { label: 'Careers', path: '/about' },
      { label: 'Contact', path: '/contact' },
    ],
    Legal: [
      { label: 'Privacy Policy', path: '/privacy-policy' },
      { label: 'Terms of Service', path: '/terms-of-service' },
    ],
  };

  const handleFooterLinkClick = (path) => (e) => {
    if (location.pathname === path) {
      e.preventDefault();
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-brand">
            <Link to="/" className="logo" onClick={handleFooterLinkClick('/')}>
              <img
                src="logo-snap-remedy-2026.svg"
                alt="Snap Remedy logo"
                className="logo-img"
              />
            </Link>

            <p className="footer-tagline">
              Transforming businesses with intelligent AI solutions
            </p>

            <div className="footer-social">
              <a
                href="https://www.linkedin.com/company/snapremedy"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category} className="footer-links-column">
              <h4 className="footer-links-title">{category}</h4>
              <ul className="footer-links-list">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="footer-link"
                      onClick={handleFooterLinkClick(link.path)}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <p className="footer-copyright">
            © {currentYear} SnapRemedy. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <span className="footer-status">
              <span className="status-dot" />
              All systems operational
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;